import styled, { css } from 'styled-components/macro';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel5 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const ContentStyled = styled.div `
  width: 100%;
  padding-bottom: 24px;

  ${({ zIndex }) => zIndex &&
    css `
      z-index: ${zIndex};
    `};

  &:last-child {
    padding-bottom: 0;
  }
`;
export const QrCodeWrapperStyled = styled.div `
  text-align: center;
  padding: 32px;
`;
export const LabelStyled = styled.label `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  color: ${colorCoreBlack900Base};

  display: flex;
  font-style: normal;
  margin-bottom: 8px;
`;
export const DropdownHint = styled(RegularTextLevel5) `
  margin-top: 10px;
`;
